export const getMonthlyWeightLoss = (weight: number, percent = 0.04): number => weight * percent;

export const getMonthsCountToReachTheGoal = (
	currentWeight: number,
	goalWeight: number,
	percent = 0.04,
): number => {
	const result = (currentWeight - goalWeight) / getMonthlyWeightLoss(currentWeight, percent);
	return result > 12 ? 12 : Math.ceil(result);
};

export const getLoseWeight = (currentWeight: number, goalWeight: number): number =>
	+(currentWeight - goalWeight).toFixed(2);

export const getWeeklyWeightLoss = (weight: number, percent = 0.04): number => {
	return +(getMonthlyWeightLoss(weight, percent) / 4).toFixed(1);
};

export const getWeeksCountToReachTheGoal = (
	currentWeight: number,
	goalWeight: number,
	percent = 0.04,
): number => {
	const result = (currentWeight - goalWeight) / getWeeklyWeightLoss(currentWeight, percent);
	return Math.ceil(result);
};

export const getGoalDate = (currentWeight: number, goalWeight: number): string => {
	const monthsCount = getMonthsCountToReachTheGoal(currentWeight, goalWeight);
	const date = new Date();
	date.setMonth(date.getMonth() + Math.abs(monthsCount));

	return date.toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	});
};

export const getBMI = (
	weight?: number | null,
	height?: number | null,
	weightUnit?: string,
	heightUnit?: string,
): number => {
	if (!weight || !height || !weightUnit || !heightUnit) return 0;
	const userWeightValue = weightUnit === 'kg' ? weight : weight * 0.453592;
	const userHeightValue = heightUnit === 'cm' ? height : height * 2.54;
	const bmi = (userWeightValue / ((userHeightValue / 100) * (userHeightValue / 100))).toFixed(2);
	return +bmi;
};
